import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-healthbank-popup',
    templateUrl: './healthbank-popup.component.html',
    styleUrls: ['./healthbank-popup.component.scss']
})
export class HealthbankPopupComponent {

    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();

    image = 'https://bayer-consent-static.s3.eu-central-1.amazonaws.com/healthbank_dialog01.png';
}
